import React from 'react';
import { CiFaceSmile } from 'react-icons/ci';
import styles from './successMessage.module.css';

function SuccessMessage(props) {
    return (
        <div className={styles.successMessage}>
            <CiFaceSmile size={50} />
            <p>{props.message}</p>
        </div>
    );
}

export default SuccessMessage;
